<template>
  <v-container
    class="pa-0"
  >
    <v-card
      v-if="form"
      tile
      flat
      class="pa-3 pt-0"
    >
      <s-person-info-toolbar />

      <div class="section-header">
        <span>1. {{ $t('HR.IdentityData') }}</span>
      </div>

      <v-row
        class="my-2"
        dense
      >
        <v-col
          cols="12"
          md="4"
        >
          {{ $t('HR.ChinName') }}: {{ form.chinName }}
        </v-col>
        <v-col
          cols="12"
          md="8"
        >
          {{ $t('HR.PortName') }}: {{ form.portName }}
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          {{ $t('PublicServant.Me.PersonalInfo.StaffCode') }}: {{ form.staffCode }}
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          {{ $t('PublicServant.Me.PersonalInfo.InternalStaffCode') }}: {{ form.entityInternalStaffCode }}
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          {{ $t('PublicServant.Me.PersonalInfo.OfficialCode') }}: {{ bdrh.numForDSF }}
        </v-col>
        <v-col
          v-if="bdrh.contributionNoFPM_providentFund"
          cols="12"
          md="4"
        >
          {{ $t('PublicServant.Me.PersonalInfo.AFCode') }}: {{ bdrh.contributionNoFPM_providentFund }}
        </v-col>
        <v-col
          v-if="bdrh.contributionNoFPM_pension"
          cols="12"
          md="4"
        >
          {{ $t('PublicServant.Me.PersonalInfo.PFCode') }}: {{ bdrh.contributionNoFPM_pension }}
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          {{ $t('PublicServant.Miscellaneous.RelatedFSS.NumForFSS') }}: {{ bdrh.numForFSS }}
        </v-col>
      </v-row>
      <v-row dense>
        <v-col
          cols="12"
          md="4"
        >
          {{ $t('TrainingClient.EnterGovDate') }}: {{ momentWithHyphen(bdrh.inGovDate).format('YYYY-MM-DD') }}
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          {{ $t('TrainingClient.EnterCareerDate') }}: {{ momentWithHyphen(form.categoryStartDate).format('YYYY-MM-DD') }}
        </v-col>
      </v-row>

      <div class="section-header">
        <span>2. {{ $t('PublicServant.Personal.Contact') }}</span>
      </div>

      <v-row dense>
        <v-col
          cols="12"
          md="4"
        >
          {{ $t('PublicServant.Me.PersonalInfo.MobilePhone') }}: {{ form.mobile }}
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          {{ $t('PublicServant.Me.PersonalInfo.CompanyPhone') }}: {{ form.companyTel }}
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          {{ $t('PublicServant.Email') }}: {{ form.email }}
        </v-col>
        <v-col
          cols="12"
        >
          {{ $t('PublicServant.Me.PersonalInfo.HomeAddress') }}: {{ bdrh.chinAddress }} {{ bdrh.portAddress }}
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>

// import bdrhApi from '../../api/hr/bdrh'
import { momentWithHyphen } from '@/utils/datetimeUtil'
import bdrhStaff from '../../store/modules/hr/bdrhStaff'
import store from '../../store'
import { mapState } from 'vuex'
import { bdrhStaffModule, staffModule } from '../../store/moduleName'
import SPersonInfoToolbar from './components/SPersonInfoToolbar.vue'

if (!store.state[bdrhStaffModule]) store.registerModule(bdrhStaffModule, bdrhStaff)

export default {
  components: { SPersonInfoToolbar },
  computed: {
    ...mapState({
      form: state => state[staffModule].info,
      bdrh: state => state[bdrhStaffModule].info
    })
  },
  created () {
    if (!this.form) {
      this.$router.push('/humanResources/PersonInfo')
    }
    this.$store.dispatch(staffModule + '/getStaff')
    // bdrhApi.getStaff(staff => {
    //   this.form = staff
    // })
  },
  methods: {
    momentWithHyphen: momentWithHyphen
  }
}
</script>
